angular.module('access.Nodes')
    .directive('accNodeEsignatureStatusIcon', [function () {
        return {
            restrict: 'E',
            scope: {
                node: '<'
            },
            replace: true,
            template: '<span class="esignature-status"\
                ng-if="node.hasEsignature"\
                uib-tooltip="{{ \'esignature_indicator_tooltip\' | translate }}"\
                tooltip-placement="top"\
                tooltip-append-to-body="true">\
                <i class="icon-acc-signature"></i>\
            </span>'
        }
    }]);
